import { inject } from '@angular/core';
import { WlService } from 'src/app/common/services/wl.service';
import { doc, getDoc } from 'firebase/firestore';
import { FIRESTORE } from 'src/app/common/firebase/firebase.tokens';

export function initializeWhiteLabel(): () => Promise<void> {
  const wlService = inject(WlService);
  /** @deprecated Direct Firestore access is deprecated. Use API endpoints instead. */
  const firestore = inject(FIRESTORE);

  return () => {
    return new Promise<void>(resolve => {
      const subscription = wlService.loaded.subscribe(loaded => {
        if (loaded) {
          subscription.unsubscribe();
          resolve();
        }
      });

      const configId = wlService.getDomainConfigId();

      if (configId) {
        getDoc(doc(firestore, 'wl', configId))
          .then(wlDoc => {
            if (wlDoc.exists()) {
              const wl = wlDoc.data();
              wlService.set(wl);
            } else {
              wlService.set(undefined);
            }
          })
          .catch(error => {
            console.error('Error fetching WL config', error);
            wlService.set(undefined);
          });
      } else {
        wlService.set(undefined);
        document.title = 'EnrollHere';
      }

      // Resolve after timeout to prevent app from hanging
      setTimeout(() => {
        resolve();
      }, 3000);
    });
  };
}
